import React, { ReactElement, useEffect } from 'react';

import { useKeycloak } from '../utils/keycloakProvider';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthRoute from 'components/AuthRoute';
import UserPanel from './User/Panel';
import Medical from './User/Medical/Medical';
import Trainings from './User/Trainings';
import Qualifications from './User/Qualifications';

const appRoutes = {
  home: '/',
  login: '/logowanie',
  user: '/panel',
};

/* const appRoutersUser = {
  userPanel: '/panel/tablica',
  userEmployeeDocuments: '/panel/teczka-pracownika',
  userMedical: '/panel/teczka-pracownika/badania',
  userTrainings: '/panel/teczka-pracownika/szkolenia',
  userQualifications: '/panel/teczka-pracownika/uprawnienia',
}; */

export const appRoutersUser = {
  userPanel: '/panel/tablica',
  userEmployee: '/panel/teczka-pracownika',
  userEmployeeMedical: '/panel/teczka-pracownika/badania',
  userEmployeeTrainings: '/panel/teczka-pracownika/szkolenia',
  userEmployeeQualifications: '/panel/teczka-pracownika/uprawnienia',
};

export const RoutedContent = (): ReactElement => {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (keycloak && !keycloak.authenticated) {
      keycloak.login();
    }
  }, [keycloak]);

  return (
    <Switch>
      <Route exact path={appRoutersUser.userPanel}>
        <UserPanel />
      </Route>

      <Route exact path={appRoutes.home}>
        <Redirect to={appRoutersUser.userPanel} />
      </Route>

      <Route exact path={appRoutes.user}>
        <Redirect to={appRoutersUser.userPanel} />
      </Route>

      <Route exact path={appRoutersUser.userEmployee}>
        <Redirect to={appRoutersUser.userEmployeeMedical} />
      </Route>

      <Route exact path={appRoutersUser.userEmployeeMedical}>
        <Medical />
      </Route>

      <Route exact path={appRoutersUser.userEmployeeQualifications}>
        <Qualifications />
      </Route>

      <Route exact path={appRoutersUser.userEmployeeTrainings}>
        <Trainings />
      </Route>
    </Switch>
  );
};

export default appRoutes;
